import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  public selectedFile = signal<string>('b2b.fr');

  constructor() {}
}
